export const iconFontAwesomeDevicesHardwareServer = (
	<i className="fa-solid fa-server"></i>
);
